import { render, staticRenderFns } from "./DraftVisits.vue?vue&type=template&id=b880d9fa&scoped=true"
import script from "./DraftVisits.vue?vue&type=script&lang=ts"
export * from "./DraftVisits.vue?vue&type=script&lang=ts"
import style0 from "./DraftVisits.vue?vue&type=style&index=0&id=b880d9fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b880d9fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b880d9fa')) {
      api.createRecord('b880d9fa', component.options)
    } else {
      api.reload('b880d9fa', component.options)
    }
    module.hot.accept("./DraftVisits.vue?vue&type=template&id=b880d9fa&scoped=true", function () {
      api.rerender('b880d9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/DraftVisits.vue"
export default component.exports